import React, { useEffect, useState } from "react";
import SpecSingle from "./SpecSingle";
import Button from "@mui/material/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { Card, Grid, Container, Typography, CardActions } from "@mui/material";

import AlertDialogSlide from "../Dialog";

import { useCallback } from "react";

import CardContent from "@mui/material/CardContent";
import { useNavigate } from "react-router-dom";
import { Diversity2Rounded } from "@mui/icons-material";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

function SpecCard(props) {
  const specs = props.spec;
  const product = props.product;
  const nav = useNavigate();
  var reqCount = 0;
  // var reqFlag = false
  const [reqFlag, setReqFlag] = useState(false);
  const [current_req, setCurrent_req] = useState({ count: 0, list: [] });
  const [currentSpec, setCurrent_Spec] = useState({ count: 0, spec: [] });
  const [price, setPrice] = useState(product.price);
  const [quantity, setQuantity] = useState(1);
  console.log("current", currentSpec);
  const [success, setSuccess] = useState(false);
  const dialogue_data = {
    yes: "Clear",
    no: "Cancel",
    primary: "Clear Cart",
    secondary: "Products from other stores are in the cart clear the cart?",
  };

  specs.map((spec) => {
    console.log(spec);
    if (spec.is_required) {
      reqCount += 1;
    }
  });
  const goToCart = () => {
    nav("/basket");
  };
  const compute_price = (sp, spec_items) => {
    var price = sp.price;
    for (let j = 0; j < spec_items.length; j++) {
      // price +=spec_items[i].list.price
      for (let i = 0; i < spec_items[j].list.length; i++) {
        price += spec_items[j].list[i].price;
        console.log("looping at ", i, j, price);
      }
    }
    var sub_total = price * quantity;
    setPrice(sub_total);
  };
  useEffect(() => {
    product.quantity = quantity;
    compute_price(product, currentSpec.spec);
    console.log("matching", reqCount, "and", currentSpec.spec.length);
    if (reqCount == 0) {
      setReqFlag(true);
    } else if (reqCount == currentSpec.spec.length) {
      setReqFlag(true);
    } else {
      setReqFlag(false);
    }
  }, [currentSpec, quantity]);
  const checkStore2 = useCallback(
    (product, currentSpec) => {
      console.log("asdfghnjml;");
      const previousStore = localStorage.getItem("store_id");
      if (previousStore !== product.store_id) {
        setSuccess(true);
      } else {
        add(product, currentSpec);
      }
    },
    [props]
  );
  const updateReq = (spec, parentspec) => {
    console.log("y is not working", parentspec);
    // if  (parentspec.type== 1)
    for (let i = 0; i < currentSpec.spec.length; i++) {
      if (currentSpec.spec[i].unique_id == parentspec.unique_id) {
        if (currentSpec.spec[i].list.length == 0) {
          var pp = currentSpec.spec;
          // const index = pp.indexOf(parentspec);
          // console.log('before remove',list,index)
          // if (index > -1) {
          pp.splice(i, 1);
          // }
          var dds = {
            count: currentSpec.count - 1,
            spec: pp,
          };
          console.log("sssssssss", dds);
          setCurrent_Spec(dds);
          compute_price(product, currentSpec.spec);
          return;
        }
        var pp = currentSpec;
        console.log("found spec", pp);
        pp.spec[i].list = parentspec.list;
        console.log(pp);
        setCurrent_Spec(pp);
        compute_price(product, currentSpec.spec);
        return;
      }
    }
    var dd = {
      count: currentSpec.count + 1,
      spec: [...currentSpec.spec, parentspec],
    };
    console.log("udated spec list is", dd);
    setCurrent_Spec(dd);
    compute_price(product, currentSpec.spec);
    // if currentSpec.includes(parentspec)
  };

  // const updateReq = (spec,parentspec) => {
  //   console.log('y is not working')
  //   // if  (parentspec.type== 1)
  //   var dd = {
  //     count: current_req.count + 1,
  //     list: [...current_req.list, spec]
  //   }
  //   console.log('udated spec list is', dd)
  //   setCurrent_req(dd)
  //   // if currentSpec.includes(parentspec)
  // }
  const removeReq = (spec, parentspec) => {
    // for (let i = 0; i < currentSpec.spec.length; i++) {
    //   if (currentSpec.spec[i].unique_id==parentspec.unique_id){
    //     var spec_item = currentSpec.spec[i].list
    //     for (let i = 0; i < spec_item.length; i++) {
    //       if (spec)
    //     }
    //   }}
    console.log("y is not working");
    var list = currentSpec.spec;
    const index = list.indexOf(parentspec);
    console.log("before remove", list, index);
    if (index > -1) {
      list.splice(index, 1);
    }
    console.log("after remove", list);
    var dd = {
      count: currentSpec.count - 1,
      spec: list,
    };
    console.log("udated spec list is", dd);
    setCurrent_Spec(dd);
  };
  // const removeReq = (spec,parentspec) => {
  //   console.log('y is not working')
  //   var list = current_req.list
  //   const index = list.indexOf(spec);
  //   console.log('before remove',list)
  //   if (index > -1) {
  //     list.splice(index, 1);
  //   }
  //   console.log('after remove',list)
  //   var dd = {
  //     count: current_req.count - 1,
  //     list: list
  //   }
  //   console.log('udated spec list is', dd)
  //   setCurrent_req(dd)
  // }
  const addQuan = function () {
    var temp = quantity + 1;
    setQuantity(temp);
  };
  const minuQuan = function () {
    if (quantity == 0) {
      return;
    }
    var temp = quantity - 1;
    setQuantity(temp);
  };
  const add = (product, cu) => {
    var temp = new Object(product);
    temp.quantity = quantity;
    console.log("this is my price", price, temp.price);
    props.addToCart(temp, cu);
    nav(-1);
  };

  console.log("required count", reqCount, reqFlag, currentSpec.spec.length);
  return (
    <Container>
      <CardContent>
        {specs.map((item) => (
          <SpecSingle
            spec={item}
            addToCart={props.addToCart}
            id={item._id}
            updateSpec={updateReq}
            removeReq={removeReq}
          ></SpecSingle>
        ))}
        {/* {reqFlag?<Button size="small" onClick={()=>{props.addToCart(product,currentSpec)}}>Add To Cart{price}</Button>:null} */}
        <div sx={{ maxWidth: 345 }}>
          <ThemeProvider theme={theme}>
            {/* <CardActions>
            <Button>
            <RemoveIcon size="medium" onClick={()=>{minuQuan()}} color='neutral'>-</RemoveIcon>
            </Button>
              {product.quantity}
              <Button>
              <AddIcon size="small" variant="contained" onClick={()=>{addQuan()}} color='neutral'>+</AddIcon>
              </Button>
              </CardActions> */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{
                  fonstSize: "0.8rem",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                Total Price: {price}
              </Typography>
              <CardActions>
                <Button
                  onClick={() => {
                    minuQuan();
                  }}
                >
                  <RemoveIcon
                    size="small"
                    style={{ width: "15px" }}
                    color="neutral"
                  >
                    -
                  </RemoveIcon>
                </Button>
                <div style={{ fonstSize: "0.8rem" }}>{quantity}</div>
                <Button
                  onClick={() => {
                    addQuan();
                  }}
                >
                  <AddIcon
                    size="small"
                    style={{ width: "15px" }}
                    color="neutral"
                  >
                    +
                  </AddIcon>
                </Button>
              </CardActions>
            </div>

            <CardActions
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Button
                disabled={!reqFlag}
                size="small"
                onClick={() => {
                  checkStore2(product, currentSpec);
                }}
                color="neutral"
                variant="contained"
              >
                Add To Cart
              </Button>

              {/* <Button disabled={!reqFlag} size="small" onClick={() => { add(product, currentSpec) }} color='neutral' variant="contained">Add To Cart</Button> */}
              {/* <Button
                size="small"
                onClick={() => {
                  goToCart();
                }}
                color="neutral"
                variant="contained"
              >
                Go to Cart
              </Button> */}
              <Button
                size="small"
                onClick={() => {
                  goToCart();
                }}
                color="neutral"
                variant="contained"
                endIcon={<ArrowForwardIcon />} // Add the arrow here
              >
                Go to Cart
              </Button>
            </CardActions>
          </ThemeProvider>
          <AlertDialogSlide
            open={success}
            data={dialogue_data}
            confirm={() => {
              add(product, currentSpec);
              setSuccess(false);
            }}
            not={() => {
              setSuccess(false);
            }}
          />
        </div>
      </CardContent>
    </Container>
  );
}

export default SpecCard;
